"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  cancelText: '取消',
  okText: '确定'
};
exports.default = _default;